import { Injectable, inject } from '@angular/core';
import { App } from '@df/core/app';
import { DfEventService } from '@df/core/service/df-event';
import { CustomerModel } from '@df/session/api/customer.model';
import { KlaviyoTrackingService } from '../../klaviyo-tracking.service';

/**
 * Klaviyo customer data change event trigger
 * Automatically identifies/updates customer in Klaviyo when customer data changes
 */
@Injectable({
    providedIn: 'root'
})
export class KlaviyoEventCustomerDataTrigger {
    /**
     * Klaviyo tracking service
     */
    private klaviyoTrackingService = inject(KlaviyoTrackingService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Customer model
     */
    private customerModel = inject(CustomerModel);

    /**
     * App service
     */
    private app = inject(App);
    /**
     * Setup event listener
     */
    constructor() {
        if (this.app.isPlatformBrowser) {
            this.init();
        }
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'customerDataChange' && this.customerModel.loaded) {
                this.dispatch();
            }
        });
    }

    /**
     * Dispatch event to Klaviyo
     * Identifies/updates customer profile in Klaviyo
     */
    private dispatch() {
        if (this.customerModel.isLoggedIn) {
            const customerData = this.customerModel.data;
            this.klaviyoTrackingService.identify({
                email: customerData.email,
                first_name: customerData.firstname,
                last_name: customerData.lastname
            });
        } else {
            this.klaviyoTrackingService.identify({});
        }
    }
}
